import { type DropdownItem } from '@/forms-legacy'
import { type RecurrenceWhen } from '../../../../types'
import { createRecurrenceWhenId } from './createRecurrenceWhenId'

export function createDaysOfWeekOptions(
  weekStartsOn: uui.domain.WeeklyValidSelection,
  formatRecurrenceWhenLabel: (recurrenceWhen: RecurrenceWhen) => string,
): DropdownItem[] {
  // Ex => startOfWeek = 6 | [0, 1, 2, 3, 4, 5, 6] => [6, 0, 1, 2, 3, 4, 5]
  const shiftedDaysOfWeek = getDaysOfWeek()
    .slice(weekStartsOn)
    .concat(getDaysOfWeek().splice(0, weekStartsOn))

  // Create array of objects with day index as key and day name as value
  return shiftedDaysOfWeek.map<DropdownItem>(weekday => {
    const recurrenceWhen: RecurrenceWhen = { type: 'WEEKLY', weekday }
    return {
      id: createRecurrenceWhenId(recurrenceWhen),
      label: formatRecurrenceWhenLabel(recurrenceWhen),
    }
  })
}

const getDaysOfWeek = () => [0, 1, 2, 3, 4, 5, 6]
